(function(){
    // This file is temporarily useless. We are not sure if the quick add button is still relevant in the new impulse theme.
    // We may need a custom re-integration

    async function clickHandler(event) {
        event.preventDefault();
        
        console.log('Click button');

        const variantId = event.target.dataset.variantId;
        const variants = event.target.dataset.variants;
        const property = event.target.dataset.property; // data-property="key:value|key:value".
        const properties = (property) ? property.split('|').reduce((properties, property) => {
          const [key, value] = property.split(':');
          properties[key] = value;
          
          return properties;
        }, {}) : {};
  
        // No Variant ID in the dataset? Thats odd. Do nothing. ( Should we remove the button from the page? )
        if(!variantId && !variants) return;
  
        event.target.classList.add('adding');
        
        let items = (variantId) ? [
          {
              id: Number(variantId),
              quantity: 1,
              properties,
          }
        ] : [...variants.split(',')].reduce((data, id, index) => {
          let inArr = data.findIndex((i) => i.id === id);
          
          if(inArr > -1) {
           data[inArr].quantity += 1
           data.splice(inArr, 1, data[inArr]);
           return data;
          }
          
          data.push({
            id: Number(id),
            quantity: 1,
            properties,
          });
          
          return data        
        }, []);
  
        theme.AjaxProduct.prototype.addItemFromData({ items }).then(() => {
            const event = new Event('cart:build');

            document.dispatchEvent(event);
            if(document.querySelector('#CartDrawer').classList.contains('drawer--is-open')) {
              const event = new Event('ajaxProduct:added');
              document.dispatchEvent(event)
              
              // document.querySelector('.js-drawer-open-cart').click();
              setTimeout(() => {
                // document.querySelector('.js-drawer-open-cart').click();
                document.querySelector('#CartDrawer .cartdrawer-wrapper').scrollTop = 0;
              }, 300)
            } else {
              document.querySelector('.js-drawer-open-cart').click();
              document.querySelector('#CartDrawer .cartdrawer-wrapper').scrollTop = 0;
            }
        })
        // await theme.cart.addItemsFromData({ items })
        //                       .then(function(itemsAdded) {
        //                           const event = new Event('cart:build');
  
        //                           document.dispatchEvent(event);
        //                           document.querySelector('.js-drawer-open-cart').click();
        //                           return;
        //                       }.bind(this))
        //                       .catch(function(XMLHttpRequest) {
        //                           this.updateError(XMLHttpRequest)
  
        //                           return;
        //                       }.bind(this));
  
        event.target.classList.remove('adding');
      }
  
      const on = (el, evt, fn, opts = {}) => {
        const delegatorFn = e =>
          e.target.matches(opts.target) && fn.call(e.target, e);
        el.addEventListener(
          evt,
          opts.target ? delegatorFn : fn,
          opts.options || false
        );
        if (opts.target) return delegatorFn;
      };

      // Delegated Event listener, so we can catch items added in via JS
      // This is a simple delegation listener for easiest integration from jquery
      on(document.body, 'click', clickHandler, { target: '.quick-add-btn' });
})();